import { useState } from "react";
import ProductListTab from "../products/ProductListTab";
import CategoriesTab from "../products/CategoriesTab";
import StockLevelsTab from "./StockLevelsTab";
import PurchaseOrdersTab from "./PurchaseOrdersTab";
import ReceiveTab from "./ReceiveTab";
import { useAuth } from "../../context/AuthContext";
import "../../styles/org-management.css";

const TABS = [
  { id: "products", label: "Products", icon: "📦", tier: "free" },
  { id: "categories", label: "Categories", icon: "🏷️", tier: "free" },
  { id: "stock", label: "Stock Levels", icon: "📊", tier: "starter" },
  { id: "purchase-orders", label: "Purchase Orders", icon: "📋", tier: "starter" },
  { id: "receive", label: "Receive", icon: "📥", tier: "starter" },
] as const;

type TabId = (typeof TABS)[number]["id"];

const PLAN_ORDER = ["free", "starter", "professional", "enterprise"];

export default function InventoryPage() {
  const { organization } = useAuth();
  const currentPlan = organization?.plan || "free";
  const [activeTab, setActiveTab] = useState<TabId>("products");

  const canAccess = (tier: string) =>
    PLAN_ORDER.indexOf(currentPlan) >= PLAN_ORDER.indexOf(tier);

  return (
    <div>
      <h1>Inventory</h1>
      <p className="page-subtitle">Manage your product catalog, purchase orders, and stock levels</p>

      <div className="org-mgmt-tabs">
        {TABS.map((tab) => {
          const locked = !canAccess(tab.tier);
          return (
            <button
              key={tab.id}
              className={`org-mgmt-tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => !locked && setActiveTab(tab.id)}
              type="button"
              style={locked ? { opacity: 0.5, cursor: "not-allowed" } : {}}
              title={locked ? `Requires ${tab.tier} plan` : ""}
            >
              <span>{tab.icon}</span>
              {tab.label}
              {locked && <span style={{ fontSize: "0.7rem", marginLeft: "0.25rem" }}>🔒</span>}
            </button>
          );
        })}
      </div>

      {activeTab === "products" && <ProductListTab />}
      {activeTab === "categories" && <CategoriesTab />}
      {activeTab === "stock" && canAccess("starter") && <StockLevelsTab />}
      {activeTab === "purchase-orders" && canAccess("starter") && <PurchaseOrdersTab />}
      {activeTab === "receive" && canAccess("starter") && <ReceiveTab />}
      {(activeTab === "stock" || activeTab === "purchase-orders" || activeTab === "receive") && !canAccess("starter") && (
        <div className="empty-state">
          <p>🔒 This feature requires the Starter plan or above.</p>
          <p style={{ fontSize: "0.85rem", marginTop: "0.5rem" }}>Upgrade in Settings → Billing to unlock inventory management.</p>
        </div>
      )}
    </div>
  );
}
